import React from "react";

export function useAutoExpandDayCard() {
  const dayCardRefs = React.useRef(new Map());
  const [expansionRequest, setExpansionRequest] = React.useState(null);

  const setDayCardRef = React.useCallback((day, element) => {
    if (element) {
      dayCardRefs.current.set(day, element);
      return;
    }

    dayCardRefs.current.delete(day);
  }, []);

  const requestDayCardExpansion = React.useCallback((day) => {
    if (!day) {
      return;
    }

    setExpansionRequest((currentRequest) => ({
      day,
      requestId: (currentRequest?.requestId ?? 0) + 1
    }));
  }, []);

  React.useEffect(() => {
    if (!expansionRequest?.day) {
      return undefined;
    }

    const targetCard = dayCardRefs.current.get(expansionRequest.day);
    if (!targetCard) {
      return undefined;
    }

    const frameId = window.requestAnimationFrame(() => {
      targetCard.open = true;
      targetCard.querySelector("summary")?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [expansionRequest]);

  return {
    requestDayCardExpansion,
    setDayCardRef
  };
}
